import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class Language extends ModelPrototype {
  public async list(): Promise<any> {
    try {
      return this.withUrl(`main/language/list`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
